
    <div class='sms-editor'>
        <div class='sub-title'>Edit SMS</div>
        <textarea [(ngModel)]="text" (ngModelChange)="onChange($event)"></textarea>
        <div class="options">
            <div>
                <span>
                    {{current}} / {{sms_total}}
                </span>
                <span>
                    {{parts}} Parts
                </span>
            </div>
        </div>
    </div>
    